export const INSERE_DADOS = 'INSERE_DADOS';
